import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { SignUpIcons } from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/signUpLinkNav/SignUpIcons';
import {
    AccountNavLinkWrapper,
    AccountNavText,
} from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/AccountNavigation.style';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { GoogleTagManagerState } from 'src/domains/layouts/state/googleState/GoogleTagManagerState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const SignUpLinkNav = observer('SignUpLinkNav', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const languagesState = LanguagesState.get(common);
    const { gtmSignUpWelcomePage } = GoogleTagManagerState.get(common);

    const language = languagesState.userLang ?? 'en';

    return (
        <AccountNavLinkWrapper
            dataTest='account-navigation-signup'
            isButton={true}
            onClickCallback={gtmSignUpWelcomePage}
            routeNameForGtm='signup'
            to={{ account: 'signup', promo: null }}
            variant={configState.componentVariants.accountNavVariant}
        >
            <SignUpIcons />

            <AccountNavText
                lang={language}
                variant={configState.componentVariants.accountNavVariant}
            >
                <I18n
                    langKey='account.sign-up'
                    defaultText='Sign Up'
                />
            </AccountNavText>
        </AccountNavLinkWrapper>
    );
});
